import { render, staticRenderFns } from "./StudentFiles.vue?vue&type=template&id=0a28841b&scoped=true&"
import script from "./StudentFiles.vue?vue&type=script&lang=js&"
export * from "./StudentFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a28841b",
  null
  
)

export default component.exports